export interface SurfboardSettlementEventMetadata {
  eventId: string;
  webhookEventId: string;
  created: number;
  originalCreated: number;
  retryAttempt: number;
}

export interface SurfboardSettlementSummary {
  payoutId: string;
  transactionStartDate: string; // ISO string
  transactionEndDate: string;   // ISO string
  settlementDate: string;       // ISO string
  reportType: string;           // e.g. 'DAILY'
  url: string;                  // link to settlement PDF/report
  currency: string;             // e.g. 'EUR'
  totalSale: number;
  totalRefund: number;
  fee: number;
  feeVat: number;
  debitAdjustments: number;
  creditAdjustments: number;
  payout: number;
}

export interface SurfboardSettlementEventData {
  summary: SurfboardSettlementSummary;
  transactionFileUrl: string; // URL to JSONL transactions file
  merchantId: string;
}

export interface SurfboardWebhookSettlementEvent {
  eventType: 'settlement.finalised' | string;
  metadata: SurfboardSettlementEventMetadata;
  data: SurfboardSettlementEventData;
}

// Records contained in the settlement transactions JSONL file
export interface SurfboardSettlementTransactionRecord {
  recordType: string; // 'transaction'
  transactionId: string;
  referenceId: string; // maps to our order/payment reference
  merchantId: string;
  amount: number; // minor units (as in sample)
  fee: number; // transaction fee
  feeVat: number; // processing fee (VAT)
  settledAmount: number;
  paymentMethod: string; // e.g. CARD, SWISH
  currency: string; // e.g. SEK
}

export interface SurfboardSettlementAdjustmentRecord {
  recordType:  string; // 'adjustment'
  description: string;
  type: string; // e.g. PARTNER_FEE, TERMINAL_FEE
  amount: number;
  vat: number;
  currency: string | number; // sample shows numeric ISO code "752"
}

export type SurfboardSettlementFileRecord =
  | SurfboardSettlementTransactionRecord
//  | SurfboardSettlementAdjustmentRecord;

// Type guards
export function isSurfboardSettlementTransactionRecord(
  r: unknown
): r is SurfboardSettlementTransactionRecord {
  return !!r && (r as any).recordType === 'transaction';
}

export function isSurfboardSettlementAdjustmentRecord(
  r: unknown
): r is SurfboardSettlementAdjustmentRecord {
  return !!r && (r as any).recordType === 'adjustment';
}
